import { render, staticRenderFns } from "./area_item_dialog.vue?vue&type=template&id=5c02dde9"
import script from "./area_item_dialog.vue?vue&type=script&lang=js"
export * from "./area_item_dialog.vue?vue&type=script&lang=js"
import style0 from "./area_item_dialog.vue?vue&type=style&index=0&id=5c02dde9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports